
const primaryColor: string = "#F1EFDC";
const secondaryColor: string = "#E6D2AA";
const tertiaryColor: string =  "#D36B00";
const backgroundColor: string =  "#42032C";
const smallSize: string = "14px";
const mediumSize: string = "20px";
const largeSize: string = "50px";

export {
    primaryColor, secondaryColor, tertiaryColor, backgroundColor, smallSize, mediumSize, largeSize
}